import { registerProvider } from './index';

class NullProvider {
  name = 'null';
  initialize() {}
  track() {}
  identify() {}
  pageView() {}
  revenue() {}
  timing() {}
  setConsent() {}
  flush() {}
  shutdown() {}
  reset() {}
  isHealthy() { return true; }
}

registerProvider('null', NullProvider);
export default NullProvider;
